// extracted by mini-css-extract-plugin
export default {"section":"MyProjects_section__ioTeG","cardsContainer":"MyProjects_cardsContainer__Ppewc"};